import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from "@mui/material";
import type { Feature, Polygon } from "geojson";
import { useTranslation } from "react-i18next";
import CaptureLocationMap from "../Captures/CaptureLocationMap";
import { useState } from "react";

interface CaptureEllipseMapDialogProps {
  open: boolean;
  onClose: () => void;
  ellipse: Feature<Polygon> | null;
  captureId?: number;
}

export default function CaptureEllipseMapDialog({
  open,
  onClose,
  ellipse,
  captureId,
}: Readonly<CaptureEllipseMapDialogProps>) {
  const { t } = useTranslation();
  const [isFullScreen, setIsFullScreen] = useState(false);

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth 
      fullScreen={isFullScreen}
      PaperProps={{
        sx: {
          height: isFullScreen ? "100%" : "lg"
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{ fontWeight: 600 }}>
          {t("calculations.methods.jacob-bear.results.ellipse-map-title")}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Tooltip title={isFullScreen ? t("generic.exit-fullscreen") : t("generic.fullscreen")}>
          <IconButton onClick={() => setIsFullScreen((p) => !p)}>
            {isFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </IconButton>
        </Tooltip>

        <Tooltip title={t("generic.close")}>
          <IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </DialogTitle>
      <DialogContent dividers>
        <CaptureLocationMap
          selectedCaptures={captureId ? [Number(captureId)] : []}
          captureId={captureId}
          isMaximized={isFullScreen}
          ellipse={ellipse}
          showViewDetails={false}
        />
      </DialogContent>
    </Dialog>
  );
}